import { getGa4ClientId } from '@/app/utils/getGa4ClientId';

const getTdClientId = () => {
  const tdCookie = (document.cookie || '')
    .split('; ')
    .find((row) => row.startsWith('_td='));
  return tdCookie ? tdCookie.substring('_td='.length) : '';
};

export const getAdsTracking = () => ({
  utm_source: window?._utm_source ?? '',
  utm_medium: window?._utm_medium ?? '',
  utm_campaign: window?._utm_campaign ?? '',
  utm_campaign_id: window?._utm_campaign_id ?? '',
  utm_term: window?._utm_term ?? '',
  utm_content: window?._utm_content ?? '',
  utm_adgroup_id: window?._utm_adgroup_id ?? '',
  utm_ad_id: window?._utm_ad_id ?? '',
  gclId: window?._gclid ?? '',
  fbclid: window?._fbclid ?? '',
  ttclid: window?._ttclid ?? '',
  lineUid: window?.lineUid ?? '',
  userId: getTdClientId(),
  gaId: getGa4ClientId(),
});

export const getSkipCallCenter = () => {
  const payload: { skipCallCenter?: boolean } = {};
  const sources = ['performancemax'];

  if (sources.includes(window._utm_source)) {
    payload.skipCallCenter = false;
  }

  return payload;
};
